import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const CompanySiret = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('companyImmatriculation', {
          required: t('mainReporting:form.mandatory'),
          validate: value => /^\d{14}$/.test(value) || t('mainReporting:form.companySiret.errors.pattern')
        })}
        label={t('mainReporting:form.companySiret.label')}
        placeholder={t('mainReporting:form.companySiret.placeholder')}
        allowOnly={/\d+/}
      />
      <InputError error={error} />
    </>
  )
}

export default CompanySiret
